import React, { useEffect } from "react";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

import AOS from "aos";

import "./outsourcing.css";

export default function Outsourcing() {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      <Navbar />
      <div className="container pt-5 py-3">
        <h1
          className="text-center py-4 pt-5 fw-bold text-danger"
          data-aos="zoom-in"
        >
          OUTSOURCING
        </h1>
        <div
          className="mainContentOutsourcing pb-5 d-flex justify-content-between"
          data-aos="zoom-in"
        >
          <div className="text-center mx-lg-5">
            <img
              src={require("../../assets/Image-Outsourch-2.png")}
              alt="imgOutsourcing"
              className="imgOutsourcing"
            />
          </div>
          <div className="descriptionOutsourcing px-lg-5 mx-lg-5 px-md-3">
            <p>
              Sejak tahun 2019, PT Kairos Cahaya Cemerlang (3GINDONEISA), telah
              dipercaya oleh perusahaan-perusahaan dari berbagai industri dalam
              memberikan jasa alih daya dalam area recruitment service.
            </p>
            <p>
              3G Indonesia sangat berpengalaman dalam menyediakan jasa tenaga
              kerja profesional untuk keperluan sales promotion dan marketing 3G
              Indonesia menangani berbagai kegiatan promosi seperti promosi
              regular do store, event, branding team, canvassing, dan lainnya.
            </p>
            <p>
              Setiap layanan jasa yang ditawarkan oleh 3G Indonesia hadir dengan
              sebuah teknologi baru yang membuat Anda tidak perlu menyediakan
              waktu khusus hanya untuk memonitor kerja tim di lapangan. Aplikasi
              yang dikembangkan oleh 3G Indonesia membuat Anda bisa bersantai
              sambil memonitor kerja tim dan juga mengirimkan tugas hanya dari
              satu tempat saja. Kapanpun, dimanapun.
            </p>
          </div>
        </div>
        <h2 className="fw-bold">APA YANG KAMI TAWARKAN ?</h2>
        <div className="d-flex justify-content-around py-lg-3 cardSpgOutsourcing">
          <div className="col card" data-aos="fade-up-right">
            <div className="text-center">
              <img
                src={require("../../assets/spg1.png")}
                alt="imgOutsourcing"
                width={200}
                className="rounded-4 pt-2"
              />
            </div>
            <div className="card-body">
              <h5 className="card-title py-lg-3 fs-3 fw-bold text-center">
                Sales Promotion Girls
              </h5>
              <p className="card-text descriptionSpgOutsourcing text-center">
                Kami membantu memasarkan produk Anda melalui tenaga professional
                yang kami miliki. Dengan tenaga kerja professional terlatih dan
                penuh integritas, serta layanan teknologi yang kami sertakan
                didalamnya, kami yakin dapat memenuhi ekspektasi Anda.
              </p>
            </div>
          </div>
          <div
            className="col card mx-lg-4 mx-md-3 merchandiser"
            data-aos="fade-up"
          >
            <div className="text-center">
              <img
                src={require("../../assets/spg2.png")}
                alt="imgOutsourcing"
                width={200}
                className="rounded-4 pt-2"
                // className="img-fluid"
              />
            </div>
            <div className="card-body">
              <h5 className="card-title py-lg-3 fs-3 fw-bold text-center">
                Merchandiser
              </h5>
              <p className="card-text descriptionSpgOutsourcing text-center">
                Merchandiser Kami siap menjadi team untuk memastikan Display
                product Perusahaan tertata dengan rapi, bersih sesuai dengan
                Planogram Outlet serta memastikan setiap program dan promosi
                berjalan dengan POP & POSM sebagaimana mestinya.
              </p>
            </div>
          </div>
          <div className="col card" data-aos="fade-up-left">
            <div className="text-center">
              <img
                src={require("../../assets/spg3.png")}
                alt="imgOutsourcing"
                width={200}
                className="rounded-4 pt-2"
                // className="img-fluid"
              />
            </div>
            <div className="card-body">
              <h5 className="card-title py-lg-3 fs-3 text-center fw-bold">
                Team Leader
              </h5>
              <p className="card-text descriptionSpgOutsourcing text-center">
                Team Leader kami siap menjadi Project Leader Bisnis Anda,
                sebagai Garda terdepan untuk mengontrol serta memonitoring
                berjalan nya kegiatan dan promosi di lapangan (in-store dan
                out-store).
              </p>
            </div>
          </div>
        </div>

        <div
          className="mb-3 py-4"
          style={{ maxWidth: "1280px" }}
          data-aos="flip-up"
        >
          <div className="row g-0">
            <div className="col-md-8">
              <div className="card-body">
                <h4 className="card-title fw-bold pb-3">Phoenix Apps</h4>
                <p className="card-text fs-5">
                  Setiap jasa yang kami tawarkan hadir dengan sebuah
                  <span className="fw-bold"> TEKNOLOGI.</span>
                </p>
                <div className="card-text">
                  <a href="/aplikasi-phoenix" className="btn btn-danger">
                    Pelajari Lebih Lanjut {">"}
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <img
                src={require("../../assets/phoenixapps.png")}
                className="rounded-start"
                alt="..."
                width={180}
              />
            </div>
          </div>

          {/* <p className="fs-4 py-lg-4">
            Setiap jasa yang kami tawarkan hadir dengan sebuah
            <span className="fw-bold"> TEKNOLOGI.</span>
          </p>
          <p></p> */}
        </div>
        {/* <div className="row align-items-center">
          <div className="col text-center">
            <img
              src={require("../../assets/Image-Outsourch-1.png")}
              alt="imgOutsourcing"
              // className="img-fluid"
            />
          </div>
          <div className="col text-center">
            <img
              src={require("../../assets/Image-Outsourch-3.png")}
              alt="imgOutsourcing"
              // className="img-fluid"
            />
          </div>
        </div> */}
      </div>
      <Footer />
    </>
  );
}
